module.exports = "pegasus/assets/theme3/header-image.jpg";